import './Header.css';
import logo from '../../assets/Logos/SpiffyLogo.svg';
import { Image } from 'react-bootstrap';
import ClaimOfferButton from '../ClaimOfferButton/ClaimOfferButton'

// Top Header
const headerTop = (props) => {
  console.log("HeaderTop props: ", props)
  return (
    <div className="headerTop">
      <div className='headerInnerLeft'/>
      <div className='headerInnerTop'>
        <Image className='headerImg' src={logo}></Image>
        {/* <h1 className="headerTopText">Smart Tumbler&trade;</h1> */}
        <h1 className="headerTopText">Smart Tumbler<small style={{ fontSize: '.5em', position: 'absolute' }}>&trade;</small></h1>
        <h1 className="headerTopText">Starter Kit</h1>
        <div className='headerTopTextSub'>Eliminating odors for happier guests & hosts</div>
      </div>
      <div className='headerInnerRight'>
        <ClaimOfferButton refProp={props.refProp}/>
      </div>
    </div >
  );
}

// Bottom Header Info Paragraph
const headerBottom = () => {
  return (
    <div className="headerBottom">
      <h1 className="headerBottomH1">Welcome, Turo hosts!</h1>
      <p className='headerP'>We heard lingering odors are a leading cause of negative feedback from both Turo guests and hosts, and we're here to help. Turo is partnering with Spiffy to offer Smart Tumbler&trade; odor elimination devices so you and your guests can breathe easier.</p>
      <p className='headerP'>
        The Smart Tumbler is a user-friendly, reliable solution for odor-removal of organic materials, smoke molecules, and bacteria. It automates the deodorizing process for your vehicles, leaving them completely odor-free in only 20 minutes.
      </p>
    </div>
  )
}

// Main Header
const Header = (props) => {
  console.log("Header props: ", props)
  return (
    <div className="headerContainer">
      {headerTop(props)}
      {headerBottom()}
    </div>
  )
}

export default Header;
